import { render, staticRenderFns } from "./Lista-Laboratori.vue?vue&type=template&id=425b416f&scoped=true&"
import script from "./Lista-Laboratori.vue?vue&type=script&lang=js&"
export * from "./Lista-Laboratori.vue?vue&type=script&lang=js&"
import style0 from "./Lista-Laboratori.vue?vue&type=style&index=0&id=425b416f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425b416f",
  null
  
)

export default component.exports